import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";

interface ScoreResultDisplayProps {
    score: number | null;
    resultNote: string;
}

export const ScoreResultDisplay = ({ score, resultNote }: ScoreResultDisplayProps) => {
    const { t } = useTranslate();

    return (
        <>
            <Grid container alignItems={'center'} justifyContent={'flex-start'} >
                <Grid
                    md={6}
                    xs={6}
                    sx={{
                        borderBottom: 'none',
                        minHeight: "45px",
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                        {t("score")}
                    </ByzMuiTypography>
                </Grid>
                <Grid
                    md={6}
                    xs={6}
                    sx={{
                        minHeight: "45px",
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <ByzMuiTextField
                        sx={{ width: "300px !important", marginLeft: "10px" }}
                        color='info'
                        disabled
                        value={score !== null && score > 0 ? score : ''}
                        label={t("score")}
                        variant="outlined"
                    />
                </Grid>
            </Grid>

            {resultNote && (
                <Grid container alignItems={'center'} justifyContent={'space-between'}>
                    <Grid md={12} xs={12} sx={{
                        backgroundColor: 'rgb(231, 239, 252)',
                        borderRadius: 1,
                        p: 2,
                        mt: 2
                    }}>
                        <ByzMuiTypography
                            sx={{ whiteSpace: 'pre-line' }}
                            fontWeight={500}
                            fontSize={'14px'}
                        >
                            {resultNote}
                        </ByzMuiTypography>
                    </Grid>
                </Grid>
            )}
        </>
    );
};
